
import API from '@/api/index';
import _ from 'lodash';
import {PAGES} from '@/utils/index';

export default {
    data() {
        return {
            lastSeenCourses: [],
            lastSeenUsers: [],
            lastSeenCatalogues: [],
            lastSeenForms: [],
            lastSearchedCourses:[],
            lastSearchedUsers:[],
            lastSearchedCatalogues:[],
            lastSearchedForms:[],
            lastSearchedApplications: [],
            lastSeenApplications: [],
        }
    },
    methods:{
        storingCourse(){
            if (localStorage.hasOwnProperty('lastSeenCourses')) {
                // pass everything in this varible of localStorage, and set the array in localStorage
                this.lastSeenCourses = JSON.parse(localStorage.getItem('lastSeenCourses'));
                localStorage.setItem('lastSeenCourses', JSON.stringify(this.lastSeenCourses));

            }else{
            // if lastseencourses is empty, pass everything to lastSeenCourses of localStorage or put an empty array
                this.lastSeenCourses = JSON.parse(localStorage.getItem('lastSeenCourses')) || [];
            }
        },
        storingApplication(){
            if (localStorage.hasOwnProperty('lastSeenApplications')) {
                // pass everything in this varible of localStorage, and set the array in localStorage
                this.lastSeenApplications = JSON.parse(localStorage.getItem('lastSeenApplications'));
                localStorage.setItem('lastSeenApplications', JSON.stringify(this.lastSeenApplications));

            }else{
            // if lastseenapplications is empty, pass everything to lastSeenApplications of localStorage or put an empty array
                this.lastSeenApplications = JSON.parse(localStorage.getItem('lastSeenApplications')) || [];
            }
        },
        saveCourseLocal(){
            this.storingCourse();

            let inArray = this.lastSeenCourses.find(course => course.id_course == this.course.id_course)
            if (!inArray) {
                let object = {
                    id_course: this.course.id_course,
                    course_name: this.course.course_name
                }
                if(Object.keys(this.lastSeenCourses).length > 4){
                    this.lastSeenCourses.splice(0, 1);
                }
                this.lastSeenCourses.push(object);
                localStorage.setItem('lastSeenCourses', JSON.stringify(this.lastSeenCourses));
            }
        },
        saveApplicationLocal(){
            this.storingApplication();

            let inArray = this.lastSeenApplications.find(course => course.id_course == this.course.id_course)
            if (!inArray) {
                let object = {
                    id_course: this.course.id_course,
                    course_name: this.course.course_name
                }
                if(Object.keys(this.lastSeenApplications).length > 4){
                    this.lastSeenApplications.splice(0, 1);
                }
                this.lastSeenApplications.push(object);
                localStorage.setItem('lastSeenApplications', JSON.stringify(this.lastSeenApplications));
            }
        },
        storingUser(){
            if (localStorage.hasOwnProperty('lastSeenUsers')) {
                this.lastSeenUsers = JSON.parse(localStorage.getItem('lastSeenUsers'));
                localStorage.setItem('lastSeenUsers', JSON.stringify(this.lastSeenUsers));

            }else{
                this.lastSeenUsers = JSON.parse(localStorage.getItem('lastSeenUsers')) || [];
            }
        },
        saveUserLocal(){
            this.storingUser()
            let inArray = this.lastSeenUsers.find(userArray => userArray.userCourses.user.id_user == this.userCourses.user.id_user)
            if (!inArray) {
                let object = {
                    userCourses: this.userCourses
                }
                if(Object.keys(this.lastSeenUsers).length > 4){
                    this.lastSeenUsers.splice(0, 1);
                }
                this.lastSeenUsers.push(object);
                localStorage.setItem('lastSeenUsers', JSON.stringify(this.lastSeenUsers));
            }
        },
        storingCatalogue(){
            if (localStorage.hasOwnProperty('lastSeenCatalogues')) {
                this.lastSeenCatalogues = JSON.parse(localStorage.getItem('lastSeenCatalogues'));
                localStorage.setItem('lastSeenCatalogues', JSON.stringify(this.lastSeenCatalogues));

            }else{
                this.lastSeenCatalogues = JSON.parse(localStorage.getItem('lastSeenCatalogues')) || [];
            }
        },
        saveCatalogueLocal(){
            this.storingCatalogue()

            let inArray = this.lastSeenCatalogues.find(catalogueArray => catalogueArray.catalogue.id_category == this.catalogue.id_category)
            if (!inArray) {
                let object = {
                    catalogue: this.catalogue,
                }
                if(this.lastSeenCatalogues.length > 4){
                    this.lastSeenCatalogues.splice(0, 1);
                }
                this.lastSeenCatalogues.push(object);
                localStorage.setItem('lastSeenCatalogues', JSON.stringify(this.lastSeenCatalogues));
            }
        },
        storingForm(){
            if (localStorage.hasOwnProperty('lastSeenForms')) {
                this.lastSeenForms = JSON.parse(localStorage.getItem('lastSeenForms'));
                localStorage.setItem('lastSeenForms', JSON.stringify(this.lastSeenForms));

            }else{
                this.lastSeenForms = JSON.parse(localStorage.getItem('lastSeenForms')) || [];
            }
        },
        saveFormLocal(formToSave){
            this.storingForm()

            let inArray = this.lastSeenForms.find(formArray => formArray.form.id_form == formToSave.id_form)
            if (!inArray) {
                let object = {
                    form: formToSave
                }
                if(this.lastSeenForms.length > 4){
                    this.lastSeenForms.splice(0, 1);
                }
                this.lastSeenForms.push(object);
                localStorage.setItem('lastSeenForms', JSON.stringify(this.lastSeenForms));
            }
        },

        // Saving last searched
        storingSearch(){
            if (localStorage.hasOwnProperty('lastSearchedCourses') && localStorage.hasOwnProperty('lastSearchedUsers') && localStorage.hasOwnProperty('lastSearchedCatalogues') && localStorage.hasOwnProperty('lastSearchedForms')) {
                this.lastSearchedCourses = JSON.parse(localStorage.getItem('lastSearchedCourses'));
                localStorage.setItem('lastSearchedCourses', JSON.stringify(this.lastSearchedCourses));

                this.lastSearchedUsers = JSON.parse(localStorage.getItem('lastSearchedUsers'));
                localStorage.setItem('lastSearchedUsers', JSON.stringify(this.lastSearchedUsers));

                this.lastSearchedCatalogues = JSON.parse(localStorage.getItem('lastSearchedCatalogues'));
                localStorage.setItem('lastSearchedCatalogues', JSON.stringify(this.lastSearchedCatalogues));

                this.lastSearchedForms = JSON.parse(localStorage.getItem('lastSearchedForms'));
                localStorage.setItem('lastSearchedForms', JSON.stringify(this.lastSearchedForms));

            }else{
                this.lastSearchedCourses = JSON.parse(localStorage.getItem('lastSearchedCourses')) || [];
                this.lastSearchedUsers = JSON.parse(localStorage.getItem('lastSearchedUsers')) || [];
                this.lastSearchedCatalogues = JSON.parse(localStorage.getItem('lastSearchedCatalogues')) || [];
                this.lastSearchedForms = JSON.parse(localStorage.getItem('lastSearchedForms')) || [];
            }
        },
        saveSearchLocal(){
            this.storingSearch()

            if (this.nameSearch.length>0) {
                switch (this.selectedList) {
                    case 'courses':
                        let inArray =  this.lastSearchedCourses.find(elem => elem === this.nameSearch)

                        if (!inArray) {
                            if(this.lastSearchedCourses.length > 2){
                                this.lastSearchedCourses.splice(0, 1);
                            }
                            this.lastSearchedCourses.push(this.nameSearch)
                            localStorage.setItem('lastSearchedCourses', JSON.stringify(this.lastSearchedCourses));
                        }
                        break;
                    case 'users':
                        let inArray1 =  this.lastSearchedUsers.find(elem => elem === this.nameSearch)

                        if (!inArray1) {
                            if(this.lastSearchedUsers.length > 2){
                                this.lastSearchedUsers.splice(0, 1);
                            }
                            this.lastSearchedUsers.push(this.nameSearch)
                            localStorage.setItem('lastSearchedUsers', JSON.stringify(this.lastSearchedUsers));
                        }
                        break;
                    case 'catalogues':
                        let inArray2 =  this.lastSearchedCatalogues.find(elem => elem === this.nameSearch)

                        if (!inArray2) {
                            if(this.lastSearchedCatalogues.length > 2){
                                this.lastSearchedCatalogues.splice(0, 1);
                            }
                            this.lastSearchedCatalogues.push(this.nameSearch)
                            localStorage.setItem('lastSearchedCatalogues', JSON.stringify(this.lastSearchedCatalogues));
                        }
                        break;
                    case 'forms':
                        let inArray3 =  this.lastSearchedForms.find(elem => elem === this.nameSearch)

                        if (!inArray3) {
                            if(this.lastSearchedForms.length > 2){
                                this.lastSearchedForms.splice(0, 1);
                            }
                            this.lastSearchedForms.push(this.nameSearch)
                            localStorage.setItem('lastSearchedForms', JSON.stringify(this.lastSearchedForms));
                        }
                        break;
                    case 'applications':
                        let inArray4 =  this.lastSearchedApplications.find(elem => elem === this.nameSearch);

                        if (!inArray4) {
                            if(this.lastSearchedApplications.length > 2){
                                this.lastSearchedApplications.splice(0, 1);
                            }
                            this.lastSearchedApplications.push(this.nameSearch);
                            localStorage.setItem('lastSearchedApplications', JSON.stringify(this.lastSearchedApplications));
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        
    }
}